export default __webpack_public_path__ + "static/media/app-store-en.a10ba650.svg";